import { MarkdownRenderer } from "@/components/MarkdownRenderer";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/Card";
import { cn } from "@/lib/utils";

interface MarkdownMessageProps {
  content: string;
  heading?: string;
  align?: "left" | "right" | "center";
}

export const MarkdownMessage = ({
  content,
  heading,
  align = "center",
}: MarkdownMessageProps) => {
  return (
    <Card
      className={cn(
        "w-[70%]",
        align === "left" && "mr-auto",
        align === "right" && "ml-auto",
        align === "center" && "mx-auto",
      )}
    >
      {heading && (
        <CardHeader>
          <CardDescription>{heading}</CardDescription>
        </CardHeader>
      )}
      <CardContent>
        <MarkdownRenderer content={content} />
      </CardContent>
    </Card>
  );
};
